import { ButtonPrimary } from '../../../../../../components/ButtonPrimary';
import { Callout } from '../../../../../../components/Callout';
import styles from '../SetupIPADadosDeConcorrencia.module.scss';

type FormFooterProps = {
  isSaving?: boolean;
};

export const FormFooter = ({ isSaving = false }: FormFooterProps) => (
  <>
    <div className={styles['setup-ipa__main-config__footer']}>
      <Callout variant="warning" size="sm">
        As modificações realizadas até as 22h serão aplicadas na próxima integração de dados. Após esse horário, elas refletem na integração do dia seguinte.
      </Callout>
    </div>
    <div className={styles.footer}>
      <ButtonPrimary type="reset" theme="ghost" disabled={isSaving}>
        cancelar
      </ButtonPrimary>
      <ButtonPrimary type="submit" isLoading={isSaving}>
        salvar
      </ButtonPrimary>
    </div>
  </>
);
